const postQuestions = {
  toastrTrue: 'Sección agregado',
  toastrFalse: 'Pregunta agregada',
  txt: 'fue actualizada con éxito'
};

export default postQuestions;
